import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.signup');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-signup',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.signup/view.scss */
:host {
  display: block;
}

.signup-form-panel {
  background: rgba(255, 255, 255, 0.985);
}

.auth-copy {
  word-break: keep-all;
  overflow-wrap: break-word;
}`],
})
export class PageSignupComponent implements OnInit {
    public loading: boolean = false;
    public submitted: boolean = false;
    public errorMessage: string = '';
    public errorField: string = '';
    public data: any = this.emptyForm();

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        const check = await this.service.auth.check();
        if (check) location.href = "/";
    }

    private emptyForm() {
        return {
            name: '',
            email: '',
            acknowledge: false
        };
    }

    private async showError(message: string, field: string = '') {
        this.errorMessage = message;
        this.errorField = field;
        await this.service.render();
        setTimeout(() => {
            const target = document.getElementById(field || 'signup-error');
            target?.focus();
        }, 0);
    }

    public async signup() {
        if (this.loading) return;

        const request = JSON.parse(JSON.stringify(this.data));
        request.name = (request.name || '').trim().replace(/\s+/g, ' ');
        request.email = (request.email || '').trim().toLowerCase();
        this.errorMessage = '';
        this.errorField = '';

        if (!request.name || request.name.length > 50) {
            return await this.showError("이름을 50자 이내로 입력해주세요.", "signup-name");
        }
        if (!/^[a-z0-9]+(?:[._-][a-z0-9]+)*@[a-z0-9]+(?:-[a-z0-9]+)*(?:\.[a-z0-9]+(?:-[a-z0-9]+)*)+$/.test(request.email)) {
            return await this.showError("올바른 이메일 주소를 입력해주세요.", "signup-email");
        }
        if (!request.acknowledge) {
            return await this.showError("관리자 승인 전 접근 제한 안내를 확인해주세요.", "signup-acknowledge");
        }

        this.loading = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call("signup", {
                ...request,
                csrf_token: this.service.auth.session?.csrf_token || ''
            });
            if (code === 202) {
                this.data = this.emptyForm();
                this.submitted = true;
                await this.service.render();
                setTimeout(() => document.getElementById('signup-success-title')?.focus(), 0);
                return;
            }
            await this.showError(data?.message || "가입 신청을 처리하지 못했습니다.");
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }
}

export default PageSignupComponent;